import { TFunction } from 'i18next';
import * as yup from 'yup';

export const validationSchema = (t: TFunction) =>
  yup.object({
    autocompleteName: yup.string().required(t('proposeRestaurant.restaurantNameRequired')).trim().typeError(t('proposeRestaurant.restaurantNameInvalid')),

    autocompleteTag: yup.string(),

    placeId: yup.string().typeError(t('proposeRestaurant.onlyPlaceError')),

    tags: yup
      .array(yup.string().nullable())
      .compact((tag) => !tag)
      .min(1, t('proposeRestaurant.atLeastOneSpecialtyError')),

    alcohol: yup.boolean().required(t('proposeRestaurant.alcoholStatus')).typeError(t('proposeRestaurant.alcoholStatus')),

    phone: yup
      .string()
      .required(t('proposeRestaurant.phoneNumberRequired'))
      .matches(/^(\+33|0)[\s-]?[67][\s-]?(\d[\s-]?){8}$/, {
        message: t('proposeRestaurant.phoneNumberFormatStatus'),
        excludeEmptyString: true
      }),

    firstName: yup.string().required(t('proposeRestaurant.firstNameRequired')).trim(),

    lastName: yup.string().required(t('proposeRestaurant.lastNameRequired')).trim(),

    email: yup.string().email(t('proposeRestaurant.emailStatus')).required(t('proposeRestaurant.emailRequired')).trim(),

    uberEatsLink: yup
      .string()
      .trim()
      .ensure()
      .when({
        is: (val: any) => val && val.length > 0,
        then: (val) =>
          val.matches(
            /https?:\/\/(www\.)?ubereats\.com\/([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/,
            t('proposeRestaurant.linkUrlStatus')
          )
      })
      .nullable()
      .optional(),
    deliverooLink: yup
      .string()
      .trim()
      .ensure()
      .when({
        is: (val: any) => val && val.length > 0,
        then: (val) =>
          val.matches(
            /https?:\/\/(www\.)?deliveroo\.[a-zA-Z0-9()]{1,6}\/([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/,
            t('proposeRestaurant.linkUrlStatus')
          )
      })
      .nullable()
      .optional(),

    justEatLink: yup
      .string()
      .trim()
      .ensure()
      .when({
        is: (val: any) => val && val.length > 0,
        then: (val) =>
          val.matches(
            /https?:\/\/(www\.)?(just-eat|takeaway)\.[a-zA-Z0-9()]{1,6}\/([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/,
            t('proposeRestaurant.linkUrlStatus')
          )
      })
      .nullable()
      .optional(),

    customDeliveryLink: yup.string().trim().url().nullable().optional(),

    isPlaceAlreadyRegistered: yup.boolean(),

    suppliers: yup.array().of(yup.string()).required('Au moins un fournisseur est requis'),
    company: yup.string().required('La société est requise')
  });

export type SubscriptionRestoSchemaType = yup.InferType<ReturnType<typeof validationSchema>>;
